export default __webpack_public_path__ + "static/media/kurt-cobain.02e51dff.jpg";